import PrintHeader from './View'
export default PrintHeader